<!-- <p *ngIf="(relatedCardsLoaded$ | async) && (selectedRelatedCard$ | async)">related-card-detail works!</p> -->

<div class="card-detail-view-area__detail-user" *ngIf="(relatedCardsLoaded$ | async) && (selectedRelatedCard$ | async)">
    <h1 class="title">
        {{'CARD_DETAILS_TITLE' | translate}}</h1>

    <div class="block-card-detail card-name">
        <span class="title">{{ 'RELATED_CARD_DETAIL_CARD_NAME' | translate }}</span>
        <span>{{ (selectedRelatedCard$ | async)?.name ? (selectedRelatedCard$ | async)?.name : '-' }}</span>
    </div>

    <div class="block-card-detail card-balance">
        <span class="title">{{ 'RELATED_CARD_DETAIL_CARD_BALANCE' | translate }}</span>
        <span>{{ (selectedRelatedCard$ | async)?.wallet_balance }} {{ appStartupService.getCurrency() | translate }}</span>
    </div>

    <div *ngIf="(actions$ | async).length > 0" class="block-card-detail actions">
        <ridango-card-actions-selector [isOpened]="actionsDropdownOpened" #actionSelector
            (onDropdownStatusChange)="dropdownStateChange($event)" (onActionClicked)="actionClicked($event)"
            [actions]="(actions$ | async)" [locale]="locale"></ridango-card-actions-selector>
    </div>

    <div class="block-card-detail card-number">
        <span class="title">{{ 'RELATED_CARD_DETAIL_CARD_NUMBER' | translate }}</span>
        <span>{{ (selectedRelatedCard$ | async)?.card_nr }}</span>
    </div>

    <div class="block-card-detail card-discount" *ngIf="discount">
        <span class="title">{{ 'RELATED_CARD_DETAIL_DISCOUNT' | translate }}</span>
        <span>{{ discount }}</span>
    </div>

    <div class="block-card-detail actions-mobile">
        <ridango-card-actions-selector [isOpened]="actionsDropdownOpened" #actionSelectorMobile
            (onDropdownStatusChange)="dropdownStateChange($event)" (onActionClicked)="actionClicked($event)"
            [actions]="(actions$ | async)" [locale]="locale" #actionSelector>
        </ridango-card-actions-selector>
    </div>
</div>

<ng-template #deleteConfirmation>
    <ridango-modal [size]="'460'" [isItSmall]="true" [visible]="true" (onCloseModal)="cancelDelete()" #modal>
        <div class="modal-dialog-460__wrapper">
            <h1 id="modal-aria-label" class="modal-dialog-460__title">{{'DIALOG_CONFIRM_DELETE_RELATED_CARD_TITLE' |
                translate}}</h1>

            <div class="margin-bottom-30">
                <p>{{'DIALOG_CONFIRM_DELETE_RELATED_CARD_DESCRIPTION' | translate}}</p>
                <div class="block block--bg-bullets margin-bottom-20">
                    <ul class="diferent-bullets" [innerHTML]="'CARD_DELETE_MODAL_LIST_ITEMS_INNER_HTML' | translate">
                    </ul>
                </div>
                <p>{{'DIALOG_CONFIRM_DELETE_RELATED_CARD_DESCRIPTION_BOTTOM' | translate}}</p>
                <hr>
            </div>

            <div class="align-center">
                <button class="btn btn--big btn--primary btn--maximal margin-bottom-20" (click)="confirmDelete()"
                    (keydown.enter)="confirmDelete()" (keydown.space)="confirmDelete()"
                    tabindex="0">{{'DIALOG_CONFIRM_DELETE_BUTTON_OK' | translate}}</button>

                <a class="link link--emphasized link--action modal-dialog__cancel-link" (click)="cancelDelete()"
                    (keydown.enter)="cancelDelete()" (keydown.space)="cancelDelete()" tabindex="0"
                    #deleteDialogFocus>{{'DIALOG_BUTTON_CANCEL' | translate}}</a>
            </div>
        </div>
    </ridango-modal>
</ng-template>

<ridango-ui-basic-loading-spinner [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate"
    *ngIf="!(relatedCardsLoaded$ | async) || !(selectedRelatedCard$ | async)">
</ridango-ui-basic-loading-spinner>

<ng-template #blockConfirmation>
    <ridango-modal [size]="'460'" [isItSmall]="true" [visible]="true" (onCloseModal)="blockCardCanceled()" #modal>
        <div class="modal-dialog-460__wrapper">
            <h1 id="modal-aria-label" class="modal-dialog-460__title">
                {{'CARD_BLOCKING_MODAL_TITLE' | translate}} </h1>

            <div class="margin-bottom-30">
                <p>
                    {{'CARD_BLOCKING_MODAL_DESCRIPTION_1' | translate}}</p>
                <p>
                    {{'CARD_BLOCKING_MODAL_DESCRIPTION_2' | translate}}</p>
                <p>
                    {{'CARD_BLOCKING_MODAL_LIST_TITLE' | translate}}</p>


                <div class="block block--bg-bullets margin-bottom-20">
                    <ul class="diferent-bullets" innerHtml="{{'CARD_BLOCKING_MODAL_LIST_ITEMS_INNER_HTML' | translate}}">
                    </ul>
                </div>
                <p *ngIf="!env.RELATED_CARD.BLOCK_WITH_FORM" innerHtml="{{'CARD_BLOCKING_MODAL_CONFIRMATION_TEXT' | translate}}"></p>
                <p *ngIf="env.RELATED_CARD.BLOCK_WITH_FORM" innerHtml="{{'CARD_BLOCKING_MODAL_REPLACEMENT_TEXT' | translate}}"></p>
            </div>

            <div *ngIf="env.RELATED_CARD.BLOCK_WITH_FORM" class="margin-bottom-30">
                <span class="checkbox-wcag">
                    <input type="checkbox" attr.aria-hidden="true" class="checkbox-wcag__checkbox" tabindex="-1"
                        [checked]="replaceCardConfirmed" attr.aria-label="{{ 'READ_TERMS_CHECKBOX_ARIA_LABEL' | translate }}"/>
                    <span class="checkbox-wcag__checkmark" tabindex="0" (click)="toggleReplaceCardCheckbox()"
                        (keydown.space)="toggleReplaceCardCheckbox()" attr.aria-checked="{{ replaceCardConfirmed }}" role="checkbox"
                        attr.aria-label="{{ 'RELATED_CARD_REPLACEMENT_CHECKBOX_ARIA_LABEL' | translate }}">
                    </span>
                    <label class="checkbox-wcag__label checkbox-wcag__label--large-offset">
                        <span class="link-label" (click)="toggleReplaceCardCheckbox()"
                            (keydown.enter)="toggleReplaceCardCheckbox()" (keydown.space)="toggleReplaceCardCheckbox()">
                            {{ 'RELATED_CARD_REPLACEMENT_CHECKBOX' | translate }}
                        </span>
                    </label>
                </span>
            </div>

            <form ridangoFocusInvalidInput [hidden]="!env.RELATED_CARD.BLOCK_WITH_FORM" [formGroup]="replaceCardForm" class="block--bg-bullets margin-bottom-30">
                <div>
                    <p>{{'REQUIRED_FIELDS_FORM_TITLE' | translate}}</p>
                </div>

                <div class="edit-profile-account-items-area__item">
                    <ridango-form-field class="form-margin-10">
                        <input ridangoInput [formControl]="replaceCardForm.controls.first_name"
                            name="first_name" type="text" required>
                        <ridango-label>{{'PH_FIRST_NAME' | translate}}</ridango-label>
                    </ridango-form-field>
                </div>

                <div class="edit-profile-account-items-area__item">
                    <ridango-form-field class="form-margin-10">
                        <input ridangoInput [formControl]="replaceCardForm.controls.last_name"
                            name="last_name" type="text" required>
                        <ridango-label>{{'PH_LAST_NAME' | translate}}</ridango-label>
                    </ridango-form-field>
                </div>

                <div class="edit-profile-account-items-area__item">
                    <ridango-form-field class="form-margin-10">
                        <input ridangoInput [formControl]="replaceCardForm.controls.adr_street"
                            name="adr_street" type="text" required>
                        <ridango-label>{{'PH_ADDRESS' | translate}}</ridango-label>
                    </ridango-form-field>
                </div>

                <div class="edit-profile-account-items-area__item">
                    <ridango-form-field class="form-margin-10">
                        <input ridangoInput [formControl]="replaceCardForm.controls.adr_city"
                            name="adr_city" type="text" required>
                        <ridango-label>{{'PH_CITY' | translate}}</ridango-label>
                    </ridango-form-field>
                </div>

                <div class="edit-profile-account-items-area__item">
                    <ridango-form-field class="form-margin-10">
                        <input ridangoInput [formControl]="replaceCardForm.controls.adr_zip"
                            name="adr_zip" type="text" required>
                        <ridango-label>{{'PH_POSTAL_CODE' | translate}}</ridango-label>
                        <ridango-error
                            *ngIf="replaceCardForm.controls.adr_zip.touched && replaceCardForm.controls.adr_zip.hasError('pattern')">
                            {{'LOCAL_INPUT_VALIDATION_POSTAL_PATTERN' | translate}}</ridango-error>
                    </ridango-form-field>
                </div>
            </form>

            <div *ngIf="env.RELATED_CARD.BLOCK_WITH_FORM" class="margin-bottom-30">
                <p innerHtml="{{'CARD_BLOCKING_MODAL_CONFIRMATION_TEXT' | translate}}"></p>
            </div>

            <div class="align-center">
                <button class="btn btn--big btn--primary btn--maximal margin-bottom-20" (click)="blockCardConfirmed()"
                    [disabled]="env.RELATED_CARD.BLOCK_WITH_FORM && replaceCardConfirmed && (replaceCardForm.pristine || replaceCardForm.invalid)"
                    (keydown.enter)="blockCardConfirmed()" (keydown.space)="blockCardConfirmed()"
                    tabindex="0">{{'CARD_BLOCKING_MODAL_BUTTON' | translate}}</button>

                <a class="link link--emphasized link--action modal-dialog__cancel-link" (click)="blockCardCanceled()"
                    (keydown.enter)="blockCardCanceled()" (keydown.space)="blockCardCanceled()"
                    tabindex="0">{{'CARD_BLOCKING_MODAL_CANCEL' | translate}}</a>
            </div>
        </div>
    </ridango-modal>
</ng-template>
